var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 412,
    viewBox: "0 0 412 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_525_4611)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 412,
    rx: 10,
    fill: "#F8F9F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 163,
    r: 85.5,
    fill: "#C8D0CE",
    stroke: "#C8D0CE",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5 372.361C69.5 319.771 106.353 274.419 157.748 263.605L171.649 269.435C192.658 278.245 216.333 278.199 237.308 269.308L250.767 263.602C304.101 274.408 342.5 321.306 342.5 375.794V426.5H69.5V372.361Z",
    fill: "#C8D0CE",
    stroke: "#C8D0CE",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_4611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 412,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotPhoto);
export default __webpack_public_path__ + "static/media/notPhoto.bf7248bde20a8938eb60dd67c09db5dd.svg";
export { ForwardRef as ReactComponent };